import React from 'react';
import { branch } from 'baobab-react/higher-order';
import Link from '../common/TrackedLink';
import config from "../../config";

class ProductDetailSupport extends React.Component {

	render() {
		let productManual = (
			<li className="col sm-4">
				<h3>Product Manual</h3>
				<div className="icon">
					<img
						src={ require('../../resources/img/icons/product-manual-icon.png') }
						alt=""
					/>
				</div>
				<p>Download the latest owner&rsquo;s manual for this product.</p>
				<Link
					className="arrow-link"
					to={ `/support/product-manuals/${this.props.modelNumber}` }
				>
					View Product Manual
				</Link>
			</li>

		)
		let warranty = (
			<li className="col sm-4">
				<h3>Warranty</h3>
				<div className="icon">
					<img
						src={ require('../../resources/img/icons/product-manual-icon.png') }
						alt=""
					/>
				</div>
				<p>Download the latest warranty information for this product.</p>
				<Link
					className="arrow-link"
					to={`${config.contentUrl}/sentrysafe/resources/pdf/90_day_warranty.pdf`}
					target="_blank"
				>
					View Warranty
				</Link>

			</li>

		)

		let productManualOrWarranty=productManual
		// Fire Bag
		if (this.props.modelNumber===config.SKU_FIRE_BAG) {
			productManualOrWarranty=warranty;
		}

		return (
			<section className="section section-support-callouts" id="support">
				<h2 className="section-title">Support</h2>
				<ul className="section-content row">

					{ productManualOrWarranty }
					<li className="col sm-4">
						<h3>FAQs</h3>
						<div className="icon">
							<img
								src={ require('../../resources/img/icons/faqs-icon.png') }
								alt=""
							/>
						</div>
						<p>Find answers to the most frequently asked questions.</p>
						<Link
							className="arrow-link"
							to="/support/faqs"
						>
							View FAQs
						</Link>
					</li>
					<li className="col sm-4">
						<h3>Videos</h3>
						<div className="icon">
							<img
								src={ require('../../resources/img/icons/video-icon.png') }
								alt=""
							/>
						</div>
						<p>Guides to safe setup, troubleshooting, and other support needs.</p>
						<Link
							className="arrow-link"
							to="/support/videos"
						>
							View Videos
						</Link>
					</li>
				</ul>
			</section>
		);
	}
};

export default branch({
	modelNumber: ['product', 'overView', 'modelNumber']
}, ProductDetailSupport);


// WEBPACK FOOTER //
// ./src/pages/product/ProductDetailSupport.js